export function FootballIcon({ className = "" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path className="football-icon__patch" d="m12 7.4 3 2.2-1.15 3.5h-3.7L9 9.6 12 7.4Z" />
      <path d="M12 7.4V3M9 9.6 5.2 7M10.15 13.1l-2.4 3.35M13.85 13.1l2.4 3.35M15 9.6 18.8 7M7.75 16.45l.9 3.05M16.25 16.45l-.9 3.05" />
    </svg>
  );
}
